var _g, _g2, _path, _path2, _path3, _path4, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgThreatNoFilteredResults = function SvgThreatNoFilteredResults(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 60,
    viewBox: "0 0 105 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2945_24494)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2945_24494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1125 38.3986C8.19937 37.294 8.19937 35.5031 10.1125 34.3986L42.2775 15.8281C44.1907 14.7235 47.2925 14.7235 49.2057 15.8281L55.9475 19.7205C57.8607 20.8251 57.8607 22.6159 55.9475 23.7205L23.7825 42.2909C21.8694 43.3955 18.7675 43.3955 16.8543 42.2909L10.1125 38.3986Z",
    fill: "#F3F7FA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2945_24494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9289 44.9669C31.0158 43.8623 31.0158 42.0715 32.9289 40.9669L65.0939 22.3965C67.0071 21.2919 70.1089 21.2919 72.0221 22.3965L78.7639 26.2888C80.6771 27.3934 80.6771 29.1843 78.7639 30.2888L46.5989 48.8593C44.6858 49.9639 41.5839 49.9639 39.6707 48.8593L32.9289 44.9669Z",
    fill: "#F3F7FA"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_2945_24494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1689 22.5511C45.1689 18.9505 46.2617 15.3112 50.9643 12.5964C58.9454 7.98887 71.8854 7.98887 79.8665 12.5964C84.7635 15.4234 85.5436 18.9505 85.5436 22.988C85.5436 26.7165 84.4508 30.228 79.7483 32.9427C71.7671 37.5503 58.8271 37.5503 50.846 32.9427C45.9491 30.1157 45.169 26.1517 45.1689 22.5511Z",
    fill: "#D7E1ED",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9645 16.405C58.9456 11.4567 71.8856 11.4567 79.8668 16.405C82.9419 18.3115 84.8322 20.6745 85.5376 23.1422C85.5417 22.9476 85.5436 22.7517 85.5436 22.5546C85.5436 18.826 84.4508 15.3146 79.7483 12.5998C71.7671 7.99233 58.8271 7.99233 50.846 12.5998C45.9491 15.4268 45.169 19.3909 45.1689 22.9915C45.1689 23.1903 45.1723 23.3892 45.1794 23.588C45.7763 20.9601 47.7047 18.4261 50.9645 16.405Z",
    fill: "#A1ADC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4954 33.2381C80.162 32.4683 80.162 30.5437 81.4954 29.7739L81.5415 29.7473C82.1603 29.3901 82.9226 29.3901 83.5414 29.7473L101.851 40.3174C102.518 40.7023 102.518 41.6646 101.851 42.0495L100.305 42.9421C99.6859 43.2993 98.9236 43.2993 98.3048 42.9421L81.4954 33.2381Z",
    fill: "#BCC9DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9645 29.1383C58.9456 34.0866 71.8856 34.0866 79.8668 29.1383C82.9419 27.2317 84.8322 24.8687 85.5376 22.401C85.5417 22.5956 85.5436 22.7915 85.5436 22.9887C85.5436 26.7172 84.4508 30.2286 79.7483 32.9434C71.7671 37.5509 58.8271 37.5509 50.846 32.9434C45.9491 30.1164 45.169 26.1523 45.1689 22.5517C45.1689 22.3529 45.1723 22.1541 45.1794 21.9552C45.7763 24.5831 47.7047 27.1171 50.9645 29.1383Z",
    fill: "url(#paint0_linear_2945_24494)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1791 21.1139C85.1791 24.1718 83.0791 27.0294 79.4921 29.1497C75.9162 31.2635 70.9435 32.587 65.424 32.587C59.9045 32.587 54.9318 31.2635 51.3559 29.1497C47.7689 27.0294 45.6689 24.1718 45.6689 21.1139C45.6689 18.0339 47.5447 15.181 50.9875 13.0741C54.4305 10.967 59.3978 9.64075 65.424 9.64075C71.4502 9.64075 76.4175 10.967 79.8605 13.0741C83.3033 15.181 85.1791 18.0339 85.1791 21.1139Z",
    fill: "white",
    fillOpacity: 0.01,
    stroke: "url(#paint1_linear_2945_24494)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2945_24494",
    x: 0.677734,
    y: 8.99963,
    width: 87.5215,
    height: 50.6881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0745098 0 0 0 0 0.0901961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2945_24494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2945_24494",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2945_24494",
    x: 8.67773,
    y: 14.9996,
    width: 48.7051,
    height: 30.1198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.737255 0 0 0 0 0.788235 0 0 0 0 0.870588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2945_24494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2945_24494",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2945_24494",
    x: 31.4941,
    y: 21.568,
    width: 48.7051,
    height: 30.1198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.737255 0 0 0 0 0.788235 0 0 0 0 0.870588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2945_24494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2945_24494",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_2945_24494",
    x: 41.1689,
    y: 5.14075,
    width: 48.375,
    height: 35.2577,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2945_24494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2945_24494",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2945_24494",
    x1: 45.1689,
    y1: 24.0735,
    x2: 83.9835,
    y2: 28.3635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.210168,
    stopColor: "#7B8BA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC9DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2945_24494",
    x1: 50.5837,
    y1: 10.813,
    x2: 85.6787,
    y2: 35.4031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38654,
    stopColor: "#A1ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674648,
    stopColor: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThreatNoFilteredResults, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/threat-no-filtered-results.6f08d84b2dbcc3af5023e2290f408217.svg";
export { ForwardRef as ReactComponent };